import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { LANGUAGE_VERSIONS } from "../constants";

// Ensure we have an entry for SQL in the languages list
const languages = Object.entries(LANGUAGE_VERSIONS).map(([lang, version]) => {
  if (lang.toLowerCase() === 'sql') {
    return ['SQL', version]; // Force uppercase for SQL
  }
  return [lang, version];
});

const ACTIVE_COLOR = "blue.400";

// Helper to normalize language display
const displayLanguage = (lang) => {
  if (lang.toLowerCase() === 'sql') {
    return 'TEXT'; // Always display SQL in uppercase
  }
  return lang;
};

const LanguageSelector = ({ language, onSelect, disabled = false }) => {
  // Normalize the current language for display
  const displayLang = displayLanguage(language);
  
  // Create the button with appropriate styling for when it's disabled
  const button = (
    <MenuButton 
      as={Button} 
      isDisabled={disabled}
      cursor={disabled ? "not-allowed" : "pointer"}
      _hover={disabled ? { bg: "blue.500", color: "white" } : {}}
      bg={disabled ? "blue.500" : undefined}
      color={disabled ? "white" : undefined}
    >
      {displayLang}
      {disabled && " (Locked)"}
    </MenuButton>
  );
  
  return (
    <Box ml={2} mb={4}>
      <Text mb={2} fontSize="lg">
        Language:
      </Text>

      <Menu isLazy isDisabled={disabled}>
        {disabled ? (
          <Tooltip label="Language selection is locked for TEXT editor" placement="right">
            {button}
          </Tooltip>
        ) : (
          button
        )}

        <MenuList bg="#110c1b">
          {languages.map(([lang, version]) => (
            <MenuItem
              key={lang}
              color={lang.toLowerCase() === language.toLowerCase() ? ACTIVE_COLOR : ""}
              bg={lang.toLowerCase() === language.toLowerCase() ? "gray.900" : "transparent"}
              _hover={{
                color: ACTIVE_COLOR,
                bg: "gray.900",
              }}
              onClick={() => onSelect(lang)}
            >
              {lang?.toLowerCase().includes('sql') ? 'TEXT' : lang}
              &nbsp;
              <Text as="span" color="gray.600" fontSize="sm">
                ({version})
              </Text>
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </Box>
  );
};
export default LanguageSelector;
